export class LoginRequest {
    password: string;
    userName: string;
}
export class LoginResponse {
  successMsg: string;
  errMsg: string;
  email: string;
  mobile: string;
  userType: string;
  userLevel: string;
  loginSuccess: boolean;
}
